// @generated
import { PapiBadge } from '@wix/da-papi-types';

export const badges: PapiBadge[] = [
  {
    id: 18114128,
    typeId: 2,
    name: 'priv',
    title: 'Priv',
    baseTitle: 'Priv',
    description: 'I have an unhealthy interest in the internals of DeviantArt',
    stackCount: null,
    images: [{ imageUrl: 'https://st.deviantart.net/badges/durrr.gif', className: '' }],
    assets: {
      normal: 'https://st.deviantart.net/badges/durrr.gif',
      huge: 'https://st.deviantart.net/badges/huge/durrr.gif',
    },
  },
  {
    id: 18114129,
    typeId: 5,
    name: 'brokeshit',
    title: 'Dead Fella',
    baseTitle: 'Dead Fella',
    description: 'Broke DeviantArt',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/brokeshit.gif',
        className: '',
      },
    ],
    descriptionLong: 'Under the level winter sky, I saw a thousand Llamas go by.',
    linkText: 'Under the level winter sky',
    linkUrl: 'https://www.deviantart.lan/pocotee/art/Ambulance-78649792',
    buttonText: 'Under the level winter sky',
    buttonUrl: 'https://www.deviantart.lan/brailynne/art/In-the-Ambulance-570290860',
    isSpectacular: true,
    assets: {
      normal: 'https://st.deviantart.net/badges/brokeshit.gif',
      huge: 'https://st.deviantart.net/badges/huge/brokeshit.gif',
    },
  },
  {
    id: 18114130,
    typeId: 6,
    name: 'bughunter',
    title: 'Bughunter',
    baseTitle: 'Bughunter',
    description: 'Bug hunting specialist',
    stackCount: null,
    images: [{ imageUrl: 'https://st.deviantart.net/badges/bug.gif', className: '' }],
    assets: {
      normal: 'https://st.deviantart.net/badges/bug.gif',
      huge: 'https://st.deviantart.net/badges/huge/bug.gif',
    },
  },
  {
    id: 18114131,
    typeId: 7,
    name: 'charitable',
    title: 'Charitable',
    baseTitle: 'Charitable',
    description: 'Charitable deviant',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/aidsribbon.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/aidsribbon.gif',
      huge: 'https://st.deviantart.net/badges/huge/aidsribbon.gif',
    },
  },
  {
    id: 18114132,
    typeId: 8,
    name: 'customerserviceexpert',
    title: 'Customer Service Expert',
    baseTitle: 'Customer Service Expert',
    description: 'Pretty awesome',
    stackCount: null,
    images: [{ imageUrl: 'https://st.deviantart.net/badges/cseb.gif', className: '' }],
    assets: {
      normal: 'https://st.deviantart.net/badges/cseb.gif',
      huge: 'https://st.deviantart.net/badges/huge/cseb.gif',
    },
  },
  {
    id: 18114133,
    typeId: 9,
    name: 'formervolunteer',
    title: 'Former Volunteer',
    baseTitle: 'Former Volunteer',
    description: '',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/former-volunteer.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/former-volunteer.gif',
      huge: 'https://st.deviantart.net/badges/huge/former-volunteer.gif',
    },
  },
  {
    id: 18114134,
    typeId: 10,
    name: 'halloween',
    title: 'Halloween',
    baseTitle: 'Halloween',
    description: 'Get Spooky With It',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/halloween.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/halloween.gif',
      huge: 'https://st.deviantart.net/badges/huge/halloween.gif',
    },
  },
  {
    id: 18114135,
    typeId: 11,
    name: 'helpdeskhero',
    title: 'Helpdesk Hero',
    baseTitle: 'Helpdesk Hero',
    description: 'In recognition of handling 250,000 moderation desk tickets',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/shieldsupergold.gif?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/shieldsupergold.gif?1',
      huge: 'https://st.deviantart.net/badges/huge/shieldsupergold.gif?1',
    },
  },
  {
    id: 18114136,
    typeId: 12,
    name: 'leadership',
    title: 'Leadership',
    baseTitle: 'Leadership',
    description: 'A commendable quality',
    stackCount: null,
    images: [{ imageUrl: 'https://st.deviantart.net/badges/cla.gif', className: '' }],
    assets: {
      normal: 'https://st.deviantart.net/badges/cla.gif',
      huge: 'https://st.deviantart.net/badges/huge/cla.gif',
    },
  },
  {
    id: 18114137,
    typeId: 13,
    name: 'mna',
    title: 'MN@',
    baseTitle: 'MN@',
    description: 'The Golden @ward',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/mnagold.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/mnagold.gif',
      huge: 'https://st.deviantart.net/badges/huge/mnagold.gif',
    },
  },
  {
    id: 18114138,
    typeId: 14,
    name: 'formerstaff',
    title: 'Former Staff Member',
    baseTitle: 'Former Staff Member',
    description: '',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/pheart.gif?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/pheart.gif?1',
      huge: 'https://st.deviantart.net/badges/huge/pheart.gif?1',
    },
  },
  {
    id: 18114139,
    typeId: 15,
    name: 'securitywarrior',
    title: 'Security Warrior',
    baseTitle: 'Security Warrior',
    description: 'Stop telling us that Worf got beaten up all the time.',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/worf.gif?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/worf.gif?1',
      huge: 'https://st.deviantart.net/badges/huge/worf.gif?1',
    },
  },
  {
    id: 18114140,
    typeId: 16,
    name: 'service',
    title: 'Distinguished Service',
    baseTitle: 'Distinguished Service',
    description: 'Awesome person',
    stackCount: null,
    images: [{ imageUrl: 'https://st.deviantart.net/badges/dsa.gif', className: '' }],
    assets: {
      normal: 'https://st.deviantart.net/badges/dsa.gif',
      huge: 'https://st.deviantart.net/badges/huge/dsa.gif',
    },
  },
  {
    id: 18114141,
    typeId: 19,
    name: 'sleepflag',
    title: 'Sleep Flag',
    baseTitle: 'Sleep Flag',
    description: 'Slept with a flag up',
    stackCount: 4,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/sleep_flag.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/sleep_flag.gif',
      huge: 'https://st.deviantart.net/badges/huge/sleep_flag.gif',
    },
  },
  {
    id: 18114142,
    typeId: 20,
    name: 'AlphaTester',
    title: 'Alpha Tester',
    baseTitle: 'Alpha Tester',
    description: 'Ultimate Bug Squisher',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/devbug.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/devbug.gif',
      huge: 'https://st.deviantart.net/badges/huge/devbug.gif',
    },
  },
  {
    id: 18114143,
    typeId: 22,
    name: 'fellaroundtheworld',
    title: "Fella 'round the World",
    baseTitle: "Fella 'round the World",
    description: 'Participated in the Fella Around the World Contest',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/fella_scarf.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/fella_scarf.png',
      huge: 'https://st.deviantart.net/badges/huge/fella_scarf.png',
    },
  },
  {
    id: 18114144,
    typeId: 23,
    name: 'pelican',
    title: 'Greatest Pelican In The World',
    baseTitle: 'Greatest Pelican In The World',
    description: 'The Spokesman Of Pelicanism',
    stackCount: 4,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/pelican.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/pelican.png',
      huge: 'https://st.deviantart.net/badges/huge/pelican.png',
    },
  },
  {
    id: 18114145,
    typeId: 24,
    name: 'whiskers',
    title: 'Whiskers',
    baseTitle: 'Whiskers',
    description: "Submitted to the April Fools' Day category",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/whiskers.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/whiskers.png',
      huge: 'https://st.deviantart.net/badges/huge/whiskers.png',
    },
  },
  {
    id: 18114146,
    typeId: 26,
    name: 'killedthesite',
    title: 'Grave Digger',
    baseTitle: 'Grave Digger',
    description: 'Killed the site',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/killedthesite.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/killedthesite.gif',
      huge: 'https://st.deviantart.net/badges/huge/killedthesite.gif',
    },
  },
  {
    id: 18114147,
    typeId: 27,
    name: 'murobrush',
    title: 'Brush Lover',
    baseTitle: 'Brush Lover',
    description: 'Early DeviantArt muro brush adopter',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/murobrush.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/murobrush.png',
      huge: 'https://st.deviantart.net/badges/huge/murobrush.png',
    },
  },
  {
    id: 18114148,
    typeId: 28,
    name: 'blackberry',
    title: 'BlackBerry',
    baseTitle: 'BlackBerry',
    description: 'Exclusive Neil Gaiman BlackBerry Badge',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/blackberry.gif?2',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/blackberry.gif?2',
      huge: 'https://st.deviantart.net/badges/huge/blackberry.gif?2',
    },
  },
  {
    id: 18114149,
    typeId: 29,
    name: 'robertrodriguez',
    title: 'Clapperboard',
    baseTitle: 'Clapperboard',
    description: 'Exclusive Robert Rodriguez BlackBerry Badge',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/blackberry_rr.png?2',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/blackberry_rr.png?2',
      huge: 'https://st.deviantart.net/badges/huge/blackberry_rr.png?2',
    },
  },
  {
    id: 18114150,
    typeId: 30,
    name: 'rodriguezpoll',
    title: 'Two Scoops',
    baseTitle: 'Two Scoops',
    description: 'Exclusive Robert Rodriguez Blackberry Badge',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/blackberry_icecreambadge.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/blackberry_icecreambadge.png',
      huge: 'https://st.deviantart.net/badges/huge/blackberry_icecreambadge.png',
    },
  },
  {
    id: 18114151,
    typeId: 31,
    name: 'truthcollective',
    title: 'truth® Artist Collective',
    baseTitle: 'truth® Artist Collective',
    description: 'I joined the truth® Artist Collective',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/truthcollective.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/truthcollective.gif',
      huge: 'https://st.deviantart.net/badges/huge/truthcollective.gif',
    },
  },
  {
    id: 18114152,
    typeId: 33,
    name: 'blackberrycalendar',
    title: 'BlackBerry',
    baseTitle: 'BlackBerry',
    description: 'Exclusive Calendar of Tales Badge',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/blackberry_calendar.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/blackberry_calendar.png',
      huge: 'https://st.deviantart.net/badges/huge/blackberry_calendar.png',
    },
  },
  {
    id: 18114153,
    typeId: 34,
    name: 'dAbirthday13',
    title: "birthdAy '13",
    baseTitle: "birthdAy '13",
    description: 'Celebrated lucky birthday #13',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/birthday13.png?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/birthday13.png?1',
      huge: 'https://st.deviantart.net/badges/huge/birthday13.png?1',
    },
  },
  {
    id: 18114154,
    typeId: 36,
    name: 'aprilfools_2014',
    title: 'thoughtART',
    baseTitle: 'thoughtART',
    description: "Participated in April Fools' Day 2014",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/brain_anim.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/brain_anim.gif',
      huge: 'https://st.deviantart.net/badges/huge/brain_anim.gif',
    },
  },
  {
    id: 18114155,
    typeId: 37,
    name: 'dAbirthday14',
    title: "birthdAy '14",
    baseTitle: "birthdAy '14",
    description: "Celebrated DeviantArt's 14th birthday",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/birthday14.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/birthday14.gif',
      huge: 'https://st.deviantart.net/badges/huge/birthday14.gif',
    },
  },
  {
    id: 18114156,
    typeId: 39,
    name: 'dAbirthday15',
    title: "Birthday '15",
    baseTitle: "Birthday '15",
    description: "Celebrated DeviantArt's 15th birthday",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/birthday15.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/birthday15.png',
      huge: 'https://st.deviantart.net/badges/huge/birthday15.png',
    },
  },
  {
    id: 18114157,
    typeId: 40,
    name: 'twistfate',
    title: 'Twist Fate',
    baseTitle: 'Twist Fate',
    description: 'I commented on Twist Fate!',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/twistfate.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/twistfate.gif',
      huge: 'https://st.deviantart.net/badges/huge/twistfate.gif',
    },
  },
  {
    id: 18114158,
    typeId: 41,
    name: 'dAbirthday16',
    title: "Birthday '16",
    baseTitle: "Birthday '16",
    description: "Celebrated DeviantArt's Sweet Sixteen",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/birthday16.gif?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/birthday16.gif?1',
      huge: 'https://st.deviantart.net/badges/huge/birthday16.gif?1',
    },
  },
  {
    id: 18114159,
    typeId: 42,
    name: 'planetoftheapes',
    title: 'Gorilla',
    baseTitle: 'Ape',
    description: 'Participated in Planet of the Apes Challenge',
    stackCount: 4,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/planet_gorilla.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/planet_gorilla.png',
      huge: 'https://st.deviantart.net/badges/huge/planet_gorilla.png',
    },
  },
  {
    id: 18114160,
    typeId: 43,
    name: 'pear',
    title: 'Biting Pear of Salamanca',
    baseTitle: 'Biting Pear of Salamanca',
    description: "Participated in April Fools' Day 2017",
    stackCount: null,
    images: [{ imageUrl: 'https://st.deviantart.net/badges/pear.png', className: '' }],
    assets: {
      normal: 'https://st.deviantart.net/badges/pear.png',
      huge: 'https://st.deviantart.net/badges/huge/pear.png',
    },
  },
  {
    id: 18114161,
    typeId: 44,
    name: 'carriefisher',
    title: 'May the 4th',
    baseTitle: 'May the 4th',
    description: 'Celebrating Star Wars',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/carriefisher.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/carriefisher.png',
      huge: 'https://st.deviantart.net/badges/huge/carriefisher.png',
    },
  },
  {
    id: 18114162,
    typeId: 45,
    name: 'dAbirthday17',
    title: "Birthday '17",
    baseTitle: "Birthday '17",
    description: "Celebrated DeviantArt's 17th birthday",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/birthday17.gif?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/birthday17.gif?1',
      huge: 'https://st.deviantart.net/badges/huge/birthday17.gif?1',
    },
  },
  {
    id: 18114163,
    typeId: 46,
    name: 'fanartmashup',
    title: 'Fan Art Mashup Challenge',
    baseTitle: 'Fan Art Mashup Challenge',
    description: 'Took the Fan Art Mashup Challenge',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/fanartmashup.png?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/fanartmashup.png?1',
      huge: 'https://st.deviantart.net/badges/huge/fanartmashup.png?1',
    },
  },
  {
    id: 18114164,
    typeId: 47,
    name: 'aprilfools_2018',
    title: 'DeviantArt Originals',
    baseTitle: 'DeviantArt Originals',
    description: "Participated in April Fools' Day 2018",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/originals_milo.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/originals_milo.gif',
      huge: 'https://st.deviantart.net/badges/huge/originals_milo.gif',
    },
  },
  {
    id: 18114165,
    typeId: 48,
    name: 'plurality_of_pride_month_2018',
    title: '#PluralityOfPride',
    baseTitle: '#PluralityOfPride',
    description: 'Participated in Pride Month 2018',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/plurality_of_pride_month.png?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/plurality_of_pride_month.png?1',
      huge: 'https://st.deviantart.net/badges/huge/plurality_of_pride_month.png?1',
    },
  },
  {
    id: 18114166,
    typeId: 49,
    name: 'dAbirthday18',
    title: "Birthday '18",
    baseTitle: "Birthday '18",
    description: "Celebrated DeviantArt's 18th birthday",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/birthday18.gif?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/birthday18.gif?1',
      huge: 'https://st.deviantart.net/badges/huge/birthday18.gif?1',
    },
  },
  {
    id: 18114167,
    typeId: 50,
    name: 'arg',
    title: 'Bunny the Red Panda',
    baseTitle: 'Bunny the Red Panda',
    description: 'Helped defeat ten djinn with Ari Banks and Bunny',
    stackCount: null,
    images: [{ imageUrl: 'https://st.deviantart.net/badges/arg.png?1', className: '' }],
    assets: {
      normal: 'https://st.deviantart.net/badges/arg.png?1',
      huge: 'https://st.deviantart.net/badges/huge/arg.png?1',
    },
  },
  {
    id: 18114168,
    typeId: 51,
    name: 'valentines_day',
    title: 'Show Your Heart',
    baseTitle: 'Show Your Heart',
    description: "Participated in DeviantArt's 2019 Valentine's Day celebrations",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/valentines.png?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/valentines.png?1',
      huge: 'https://st.deviantart.net/badges/huge/valentines.png?1',
    },
  },
  {
    id: 18114169,
    typeId: 52,
    name: 'khush',
    title: 'Khush',
    baseTitle: 'Khush',
    description: "Participated in April Fools' Day 2019",
    stackCount: null,
    images: [{ imageUrl: 'https://st.deviantart.net/badges/khush.gif', className: '' }],
    assets: {
      normal: 'https://st.deviantart.net/badges/khush.gif',
      huge: 'https://st.deviantart.net/badges/huge/khush.gif',
    },
  },
  {
    id: 18114170,
    typeId: 53,
    name: 'glass_heroes_vs_villains',
    title: 'Glass Heroes vs. Villains',
    baseTitle: 'Glass Heroes vs. Villains',
    description: 'Voted in the Glass Heroes vs. Villains Community Battle',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/glass_heroes_villains2.png?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/glass_heroes_villains2.png?1',
      huge: 'https://st.deviantart.net/badges/huge/glass_heroes_villains2.png?1',
    },
  },
  {
    id: 18114171,
    typeId: 54,
    name: 'deviant_visions',
    title: 'Deviant Visions',
    baseTitle: 'Deviant Visions',
    description: 'Created a video review for DeviantArt Eclipse',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/deviant_visions.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/deviant_visions.png',
      huge: 'https://st.deviantart.net/badges/huge/deviant_visions.png',
    },
  },
  {
    id: 18114172,
    typeId: 55,
    name: 'pride_month_2019',
    title: '30 Days of Pride',
    baseTitle: '30 Days of Pride',
    description: 'Participated in Pride Month 2019',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/pride_month_2019.gif?0',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/pride_month_2019.gif?0',
      huge: 'https://st.deviantart.net/badges/huge/pride_month_2019.gif?0',
    },
  },
  {
    id: 18114173,
    typeId: 56,
    name: 'dAbirthday19',
    title: "Birthday '19",
    baseTitle: "Birthday '19",
    description: "Celebrated DeviantArt's 19th birthday",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/birthday19.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/birthday19.gif',
      huge: 'https://st.deviantart.net/badges/huge/birthday19.gif',
    },
  },
  {
    id: 18114174,
    typeId: 57,
    name: 'stupid_powers',
    title: 'Stupid Powers',
    baseTitle: 'Stupid Powers',
    description: 'Participated in Stupid Powers',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/stupid_powers.gif?0',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/stupid_powers.gif?0',
      huge: 'https://st.deviantart.net/badges/huge/stupid_powers.gif?0',
    },
  },
  {
    id: 18114175,
    typeId: 58,
    name: 'valentines_day_2020',
    title: 'Share the Love',
    baseTitle: 'Share the Love',
    description: "Participated in DeviantArt's 2020 Valentine's Day celebrations.",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/valentines_day_2020.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/valentines_day_2020.gif',
      huge: 'https://st.deviantart.net/badges/huge/valentines_day_2020.gif',
    },
  },
  {
    id: 18114176,
    typeId: 59,
    name: 'aprilfools_2020',
    title: 'Hoofs',
    baseTitle: 'Hoofs',
    description: "Participated in April Fools' Day 2020",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/hoofs_neerdy_geeky_dweeb.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/hoofs_neerdy_geeky_dweeb.gif',
      huge: 'https://st.deviantart.net/badges/huge/hoofs_neerdy_geeky_dweeb.gif',
    },
  },
  {
    id: 18114177,
    typeId: 60,
    name: 'start_with_love',
    title: 'StartWithLove',
    baseTitle: 'StartWithLove',
    description: 'Participated in Start With Love campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/start_with_love.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/start_with_love.gif',
      huge: 'https://st.deviantart.net/badges/huge/start_with_love.gif',
    },
  },
  {
    id: 18114178,
    typeId: 61,
    name: 'pride_2020',
    title: 'Pride2020',
    baseTitle: 'Pride2020',
    description: 'Participated in Pride2020',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/da_pride2020_heartbadge.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/da_pride2020_heartbadge.gif',
      huge: 'https://st.deviantart.net/badges/huge/da_pride2020_heartbadge.gif',
    },
  },
  {
    id: 18114183,
    typeId: 62,
    name: 'getting_started',
    title: 'Getting Started',
    baseTitle: 'Getting Started',
    description: 'Participated in Getting Started Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/getting_started.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/getting_started.gif',
      huge: 'https://st.deviantart.net/badges/huge/getting_started.gif',
    },
  },
  {
    id: 18114184,
    typeId: 67,
    name: 'dAbirthday20',
    title: 'Birthday20',
    baseTitle: 'Birthday20',
    description: 'Participated in DA 20th Birthday campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/birthday20.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/birthday20.gif',
      huge: 'https://st.deviantart.net/badges/huge/birthday20.gif',
    },
  },
  {
    id: 18114185,
    typeId: 68,
    name: 'postsCampaign2020',
    title: 'CreatureWeek20Monday',
    baseTitle: 'CreatureWeek20Monday',
    description: 'Participated in DA Creature Week 2020 Monday',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/posts_campaign20.gif?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/posts_campaign20.gif?1',
      huge: 'https://st.deviantart.net/badges/huge/posts_campaign20.gif?1',
    },
  },
  {
    id: 18114186,
    typeId: 69,
    name: 'postsCampaign2020Thursday',
    title: 'CreatureWeek20Thursday',
    baseTitle: 'CreatureWeek20Thursday',
    description: 'Participated in DA Creature Week 2020 Thursday',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/posts_campaign20.gif?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/posts_campaign20.gif?1',
      huge: 'https://st.deviantart.net/badges/huge/posts_campaign20.gif?1',
    },
  },
  {
    id: 18114187,
    typeId: 70,
    name: 'MagicWeek20Monday',
    title: 'MagicWeek20Monday',
    baseTitle: 'MagicWeek20Monday',
    description: 'Participated in DA Magic Week 2020 Monday',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/magic_week.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/magic_week.gif',
      huge: 'https://st.deviantart.net/badges/huge/magic_week.gif',
    },
  },
  {
    id: 18114188,
    typeId: 71,
    name: 'MagicWeek20Thursday',
    title: 'MagicWeek20Thursday',
    baseTitle: 'MagicWeek20Thursday',
    description: 'Participated in DA Magic Week 2020 Thursday',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/magic_week_orange.gif?1',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/magic_week_orange.gif?1',
      huge: 'https://st.deviantart.net/badges/huge/magic_week_orange.gif?1',
    },
  },
  {
    id: 18114189,
    typeId: 72,
    name: 'ArcadeWeek20Monday',
    title: 'ArcadeWeek20Monday',
    baseTitle: 'ArcadeWeek20Monday',
    description: 'Participated in DA Arcade Week 2020 Monday',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/arcadeweek_badge.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/arcadeweek_badge.gif',
      huge: 'https://st.deviantart.net/badges/huge/arcadeweek_badge.gif',
    },
  },
  {
    id: 18114190,
    typeId: 73,
    name: 'ArcadeWeek20Thursday',
    title: 'ArcadeWeek20Thursday',
    baseTitle: 'ArcadeWeek20Thursday',
    description: 'Participated in DA Arcade Week 2020 Thursday',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/arcade_week_badge_thursday.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/arcade_week_badge_thursday.gif',
      huge: 'https://st.deviantart.net/badges/huge/arcade_week_badge_thursday.gif',
    },
  },
  {
    id: 18114191,
    typeId: 74,
    name: 'RetroWeek20Monday',
    title: 'RetroWeek20Monday',
    baseTitle: 'RetroWeek20Monday',
    description: 'Participated in DA Retro Week 2020 Monday',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/retro_week_badge_monday.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/retro_week_badge_monday.gif',
      huge: 'https://st.deviantart.net/badges/huge/retro_week_badge_monday.gif',
    },
  },
  {
    id: 18114192,
    typeId: 75,
    name: 'RetroWeek20Thursday',
    title: 'RetroWeek20Thursday',
    baseTitle: 'RetroWeek20Thursday',
    description: 'Participated in DA Retro Week 2020 Thursday',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/retro_week_badge_thursday.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/retro_week_badge_thursday.gif',
      huge: 'https://st.deviantart.net/badges/huge/retro_week_badge_thursday.gif',
    },
  },
  {
    id: 18114193,
    typeId: 77,
    name: 'BHM2021',
    title: 'BHM2021',
    baseTitle: 'BHM2021',
    description: 'Participated in Black History Month 2021 campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/black_history_month_2021.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/black_history_month_2021.gif',
      huge: 'https://st.deviantart.net/badges/huge/black_history_month_2021.gif',
    },
  },
  {
    id: 18114194,
    typeId: 79,
    name: 'DATutorialEye',
    title: 'DeviantArt Tutorials',
    baseTitle: 'DeviantArt Tutorials',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/da_tutorial_eye.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/da_tutorial_eye.gif',
      huge: 'https://st.deviantart.net/badges/huge/da_tutorial_eye.gif',
    },
  },
  {
    id: 18114195,
    typeId: 80,
    name: 'AAPI2021',
    title: 'Asian American and Pacific Islander Heritage Month 2021',
    baseTitle: 'Asian American and Pacific Islander Heritage Month 2021',
    description: 'Participated in Asian American and Pacific Islander Heritage Month 2021 campaign',
    stackCount: null,
    images: [
      {
        imageUrl:
          'https://st.deviantart.net/badges/asian_american_pacific_islander_heritage_month_2021.gif',
        className: '',
      },
    ],
    assets: {
      normal:
        'https://st.deviantart.net/badges/asian_american_pacific_islander_heritage_month_2021.gif',
      huge: 'https://st.deviantart.net/badges/huge/asian_american_pacific_islander_heritage_month_2021.gif',
    },
  },
  {
    id: 18114196,
    typeId: 81,
    name: 'DACollective',
    title: 'DeviantArt Collective',
    baseTitle: 'DeviantArt Collective',
    description: 'Member of DeviantArt Collective',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/da_collective.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/da_collective.gif',
      huge: 'https://st.deviantart.net/badges/huge/da_collective.gif',
    },
  },
  {
    id: 18114197,
    typeId: 82,
    name: 'DATutorialHand',
    title: 'DeviantArt Tutorials Hand',
    baseTitle: 'DeviantArt Tutorials Hand',
    description: 'Participated in the DeviantArt Tutorials Hand',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/deviantart_tutorial_hand_badge.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/deviantart_tutorial_hand_badge.gif',
      huge: 'https://st.deviantart.net/badges/huge/deviantart_tutorial_hand_badge.gif',
    },
  },
  {
    id: 18114198,
    typeId: 84,
    name: 'DATutorialLandscape',
    title: 'DeviantArt Tutorials Landscape',
    baseTitle: 'DeviantArt Tutorials Landscape',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/tutorial_june.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/tutorial_june.gif',
      huge: 'https://st.deviantart.net/badges/huge/tutorial_june.gif',
    },
  },
  {
    id: 18114199,
    typeId: 85,
    name: 'DATutorialSpiderMan',
    title: 'DeviantArt Tutorials Spider-Man',
    baseTitle: 'DeviantArt Tutorials Spider-Man',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/da_spiderman_badge.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/da_spiderman_badge.gif',
      huge: 'https://st.deviantart.net/badges/huge/da_spiderman_badge.gif',
    },
  },
  {
    id: 18114200,
    typeId: 86,
    name: 'TrapHeals',
    title: 'Trap Heals',
    baseTitle: 'Trap Heals',
    description: 'Participated in the Trap Heals Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/trap_heals.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/trap_heals.gif',
      huge: 'https://st.deviantart.net/badges/huge/trap_heals.gif',
    },
  },
  {
    id: 18114201,
    typeId: 87,
    name: 'DA21stBirthday',
    title: 'Birthday21',
    baseTitle: 'Birthday21',
    description: 'Participated in DA 21st Birthday campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/birthday21.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/birthday21.gif',
      huge: 'https://st.deviantart.net/badges/huge/birthday21.gif',
    },
  },
  {
    id: 18114202,
    typeId: 88,
    name: 'DATutorialFire',
    title: 'DeviantArt Tutorials Fire',
    baseTitle: 'DeviantArt Tutorials Fire',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/da_tutorial_fire.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/da_tutorial_fire.gif',
      huge: 'https://st.deviantart.net/badges/huge/da_tutorial_fire.gif',
    },
  },
  {
    id: 18114203,
    typeId: 89,
    name: 'DATutorialDragon',
    title: 'DeviantArt Tutorials Dragon',
    baseTitle: 'DeviantArt Tutorials Dragon',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/da_tutorial_dragon.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/da_tutorial_dragon.gif',
      huge: 'https://st.deviantart.net/badges/huge/da_tutorial_dragon.gif',
    },
  },
  {
    id: 18114204,
    typeId: 90,
    name: 'HispanicHeritageMonth2021',
    title: 'Hispanic Heritage Month 2021',
    baseTitle: 'Hispanic Heritage Month 2021',
    description: 'Participated in Hispanic Heritage Month 2021',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/hhm_rainbow_bird.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/hhm_rainbow_bird.gif',
      huge: 'https://st.deviantart.net/badges/huge/hhm_rainbow_bird.gif',
    },
  },
  {
    id: 18114205,
    typeId: 91,
    name: 'DATutorialCreatureWing',
    title: 'DeviantArt Tutorial Creature Wing',
    baseTitle: 'DeviantArt Tutorial Creature Wing',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/creature_wingx.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/creature_wingx.gif',
      huge: 'https://st.deviantart.net/badges/huge/creature_wingx.gif',
    },
  },
  {
    id: 18114206,
    typeId: 92,
    name: 'DATutorialCat',
    title: 'DeviantArt Tutorial Cat',
    baseTitle: 'DeviantArt Tutorial Cat',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/tutorial_cat.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/tutorial_cat.gif',
      huge: 'https://st.deviantart.net/badges/huge/tutorial_cat.gif',
    },
  },
  {
    id: 18114207,
    typeId: 93,
    name: 'DATutorialJackOLantern',
    title: 'DeviantArt Tutorials Jack O Lantern',
    baseTitle: 'DeviantArt Tutorials Jack O Lantern',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/tutorial_badge_october.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/tutorial_badge_october.gif',
      huge: 'https://st.deviantart.net/badges/huge/tutorial_badge_october.gif',
    },
  },
  {
    id: 18114208,
    typeId: 94,
    name: 'HowToDrawZatz',
    title: 'How to Draw Zatz',
    baseTitle: 'How to Draw Zatz',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/how_to_draw_zatz.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/how_to_draw_zatz.gif',
      huge: 'https://st.deviantart.net/badges/huge/how_to_draw_zatz.gif',
    },
  },
  {
    id: 18114209,
    typeId: 95,
    name: 'DayOfTheDeviant',
    title: 'Day of the Deviant',
    baseTitle: 'Day of the Deviant',
    description: 'Participated in Day of the Deviant Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/day_of_the_deviant.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/day_of_the_deviant.gif',
      huge: 'https://st.deviantart.net/badges/huge/day_of_the_deviant.gif',
    },
  },
  {
    id: 18114210,
    typeId: 96,
    name: 'GenerousGifter',
    title: 'Generous Gifter',
    baseTitle: 'Generous Gifter',
    description: 'Generously gave a Core Membership to a fellow deviant',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/generous_gifter.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/generous_gifter.gif',
      huge: 'https://st.deviantart.net/badges/huge/generous_gifter.gif',
    },
  },
  {
    id: 18114211,
    typeId: 98,
    name: 'DATutorialPikachu',
    title: 'How to Draw Pikachu',
    baseTitle: 'How to Draw Pikachu',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/tutorial_january_badge_pickachu.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/tutorial_january_badge_pickachu.gif',
      huge: 'https://st.deviantart.net/badges/huge/tutorial_january_badge_pickachu.gif',
    },
  },
  {
    id: 18114212,
    typeId: 100,
    name: 'DATutorialRose',
    title: 'How to Draw a Rose',
    baseTitle: 'How to Draw a Rose',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/tutorial_february_badge_rose.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/tutorial_february_badge_rose.gif',
      huge: 'https://st.deviantart.net/badges/huge/tutorial_february_badge_rose.gif',
    },
  },
  {
    id: 18114213,
    typeId: 101,
    name: 'DATutorialSuperhero',
    title: 'How to Draw a Superhero Profile',
    baseTitle: 'How to Draw a Superhero Profile',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/super_hero_badge.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/super_hero_badge.gif',
      huge: 'https://st.deviantart.net/badges/huge/super_hero_badge.gif',
    },
  },
  {
    id: 18114214,
    typeId: 104,
    name: 'MonaLisaFixed',
    title: 'MonaLisaFixed',
    baseTitle: 'MonaLisaFixed',
    description: "Participated in April Fools' Day 2022",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/monalisa_winner.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/monalisa_winner.gif',
      huge: 'https://st.deviantart.net/badges/huge/monalisa_winner.gif',
    },
  },
  {
    id: 18114215,
    typeId: 105,
    name: 'HowToDrawWolf',
    title: 'How to Draw a Wolf',
    baseTitle: 'How to Draw a Wolf',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/how_to_draw_a_wolf.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/how_to_draw_a_wolf.gif',
      huge: 'https://st.deviantart.net/badges/huge/how_to_draw_a_wolf.gif',
    },
  },
  {
    id: 18114216,
    typeId: 106,
    name: 'MysteryEgg',
    title: 'Mystery Egg',
    baseTitle: 'Mystery Egg',
    description:
      "You submitted your 1st deviation, amazing! But what's this...? Something has magically appeared.",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/mystery_egg_submit_small.gif',
        className: '',
      },
    ],
    descriptionLong:
      'What will happen if you feed it one more deviation? That looks like a crack....',
    buttonText: 'Submit Again',
    buttonUrl: 'https://www.deviantart.lan/submit',
    isSpectacular: true,
    assets: {
      normal: 'https://st.deviantart.net/badges/mystery_egg_submit_small.gif',
      huge: 'https://st.deviantart.net/badges/huge/mystery_egg_submit_small.gif',
    },
  },
  {
    id: 18114217,
    typeId: 107,
    name: 'BabyBlob',
    title: 'Baby Blob',
    baseTitle: 'Baby Blob',
    description: 'Achievement unlocked! Your 2nd deviation made the Mystery Egg hatch.',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/baby_blob_submit_small.gif',
        className: '',
      },
    ],
    descriptionLong:
      'Do you want your Baby Blob to grow big and strong? See what happens when you feed it 3 more deviations...',
    buttonText: 'Submit Again',
    buttonUrl: 'https://www.deviantart.lan/submit',
    isSpectacular: true,
    assets: {
      normal: 'https://st.deviantart.net/badges/baby_blob_submit_small.gif',
      huge: 'https://st.deviantart.net/badges/huge/baby_blob_submit_small.gif',
    },
  },
  {
    id: 18114218,
    typeId: 108,
    name: 'BouncingBlob',
    title: 'Bouncing Blob',
    baseTitle: 'Bouncing Blob',
    description: "Your 5th deviation's making it jump for joy!",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/bouncing_blob_submit_small.gif',
        className: '',
      },
    ],
    descriptionLong:
      "Looks like your deviation had a lot of caffeine in it, look at it go! Feed your blob 5 more nutritious deviations to see what you'll unlock next.",
    buttonText: 'Submit Again',
    buttonUrl: 'https://www.deviantart.lan/submit',
    isSpectacular: true,
    assets: {
      normal: 'https://st.deviantart.net/badges/bouncing_blob_submit_small.gif',
      huge: 'https://st.deviantart.net/badges/huge/bouncing_blob_submit_small.gif',
    },
  },
  {
    id: 18114219,
    typeId: 109,
    name: 'DiscoBlob',
    title: 'Disco Blob',
    baseTitle: 'Disco Blob',
    description: 'Groovy, baby! Your 10th deviation unlocked the funk.',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/disco_blob_submit_small.gif',
        className: '',
      },
    ],
    descriptionLong:
      "You're now an expert at submitting deviations. Thanks for making yourself at home on DeviantArt. We're glad you're here, and we hope you keep sharing your work with us.",
    buttonText: 'Submit Again',
    buttonUrl: 'https://www.deviantart.lan/submit',
    isSpectacular: true,
    assets: {
      normal: 'https://st.deviantart.net/badges/disco_blob_submit_small.gif',
      huge: 'https://st.deviantart.net/badges/huge/disco_blob_submit_small.gif',
    },
  },
  {
    id: 18114220,
    typeId: 111,
    name: 'HowToDrawMermaid',
    title: 'How to Draw a Mermaid',
    baseTitle: 'How to Draw a Mermaid',
    description: 'Participated in Tutorials Campaign',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/how_to_draw_a_mermaid.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/how_to_draw_a_mermaid.gif',
      huge: 'https://st.deviantart.net/badges/huge/how_to_draw_a_mermaid.gif',
    },
  },
  {
    id: 18114221,
    typeId: 110,
    name: 'ScoredFirstSubscriber',
    title: 'Scored 1st Subscriber',
    baseTitle: 'Scored 1st Subscriber',
    description: 'Congrats on getting your first-ever subscriber!',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/scored_first_subscriber.gif',
        className: '',
      },
    ],
    descriptionLong:
      "Let's keep the momentum going. Read on for tips on how to get even more subscribers.",
    buttonText: 'Get More Subscribers',
    buttonUrl: 'https://www.deviantart.lan/team/journal/How-to-Gain-Subscribers-902170499',
    isSpectacular: true,
    assets: {
      normal: 'https://st.deviantart.net/badges/scored_first_subscriber.gif',
      huge: 'https://st.deviantart.net/badges/huge/scored_first_subscriber.gif',
    },
  },
  {
    id: 18114222,
    typeId: 112,
    name: 'ScoredFifthSubscriber',
    title: 'Landed 5 Subscribers',
    baseTitle: 'Landed 5 Subscribers',
    description: "You're on a roll! 5 deviants think you're awesome.",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/scored_fifth_subscriber.gif',
        className: '',
      },
    ],
    descriptionLong:
      'Want more tips about how to give your subscribers the best value for their money?',
    buttonText: 'Get Ideas',
    buttonUrl:
      'https://www.deviantart.lan/team/journal/How-to-Give-Your-Subscribers-the-Best-Value-902169969',
    isSpectacular: true,
    assets: {
      normal: 'https://st.deviantart.net/badges/scored_fifth_subscriber.gif',
      huge: 'https://st.deviantart.net/badges/huge/scored_fifth_subscriber.gif',
    },
  },
  {
    id: 18114223,
    typeId: 113,
    name: 'ScoredTenthSubscriber',
    title: 'Reached 10 Subscribers',
    baseTitle: 'Reached 10 Subscribers',
    description: 'Keep up the good work!',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/scored_tenth_subscriber.gif',
        className: '',
      },
    ],
    descriptionLong:
      "You've got 10 wonderful subscribers. Why not reach out and send a nice message? They'll appreciate hearing from you.",
    buttonText: 'Check Out Your Subscribers',
    buttonUrl: 'https://www.deviantart.lan/account/customers',
    isSpectacular: true,
    assets: {
      normal: 'https://st.deviantart.net/badges/scored_tenth_subscriber.gif',
      huge: 'https://st.deviantart.net/badges/huge/scored_tenth_subscriber.gif',
    },
  },
  {
    id: 18114224,
    typeId: 114,
    name: 'ScoredFiftiethSubscriber',
    title: 'Hit 50 Subscribers',
    baseTitle: 'Hit 50 Subscribers',
    description: "You've made it to the big leagues!",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/scored_fiftieth_subscriber.gif',
        className: '',
      },
    ],
    descriptionLong:
      "50 subscribers can't get enough of you. We're glad you've chosen DeviantArt to host your subscriptions, and hope they keep doing better and better.",
    buttonText: 'Create Another Tier',
    buttonUrl: 'https://www.deviantart.lan/chris/subscriptions',
    isSpectacular: true,
    assets: {
      normal: 'https://st.deviantart.net/badges/scored_fiftieth_subscriber.gif',
      huge: 'https://st.deviantart.net/badges/huge/scored_fiftieth_subscriber.gif',
    },
  },
  {
    id: 18114225,
    typeId: 117,
    name: 'Unicorn',
    title: 'How to Draw a Unicorn',
    baseTitle: 'How to Draw a Unicorn',
    description: 'Thanks for participating in the tutorial!',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/unicorn.gif',
        className: '',
      },
    ],
    descriptionLong:
      'Your awesome submission got you this badge to proudly display on your profile! Stay tuned for more tutorials and badges.',
    buttonText: 'Learn More',
    buttonUrl:
      'https://www.deviantart.lan/team/journal/Tutorial-Draw-a-Unicorn-with-griffsnuff-915026559',
    assets: {
      normal: 'https://st.deviantart.net/badges/unicorn.gif',
      huge: 'https://st.deviantart.net/badges/huge/unicorn.gif',
    },
  },
  {
    id: 18114226,
    typeId: 118,
    name: 'HowToDrawTiger',
    title: 'How to Draw a Tiger',
    baseTitle: 'How to Draw a Tiger',
    description: 'You participated in the tutorial!',
    stackCount: null,
    images: [{ imageUrl: 'https://st.deviantart.net/badges/tiger.gif', className: '' }],
    descriptionLong:
      'Your awesome submission got you this badge to proudly display on your profile! Stay tuned for more tutorials and badges.',
    buttonText: 'Learn More',
    buttonUrl:
      'https://www.deviantart.lan/team/journal/Tutorial-Draw-a-Tiger-with-JoJoesArt-916438199',
    assets: {
      normal: 'https://st.deviantart.net/badges/tiger.gif',
      huge: 'https://st.deviantart.net/badges/huge/tiger.gif',
    },
  },
  {
    id: 18114227,
    typeId: 119,
    name: 'FourEveningsAtFellas',
    title: 'Birthday22',
    baseTitle: 'Birthday22',
    description: 'You partied with Fella and friends!',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/birthday22.gif',
        className: '',
      },
    ],
    descriptionLong: "You survived Four Evenings at Fella's! Are you full of fright… and pizza?",
    buttonText: 'Get Seconds',
    buttonUrl:
      'https://www.deviantart.lan/team/journal/Let-s-Party-Celebrate-DeviantArt-s-22nd-Birthday-918559977',
    assets: {
      normal: 'https://st.deviantart.net/badges/birthday22.gif',
      huge: 'https://st.deviantart.net/badges/huge/birthday22.gif',
    },
  },
  {
    id: 18114228,
    typeId: 120,
    name: 'HowToDrawARaven',
    title: 'How to Draw a Raven',
    baseTitle: 'How to Draw a Raven',
    description: 'You participated in the tutorial!',
    stackCount: null,
    images: [{ imageUrl: 'https://st.deviantart.net/badges/raven.gif', className: '' }],
    descriptionLong:
      'Your awesome submission got you this badge to proudly display on your profile! Stay tuned for more tutorials and badges.',
    buttonText: 'Learn More',
    buttonUrl:
      'https://www.deviantart.lan/team/journal/Tutorial-Draw-a-Raven-with-DanKendi-920120237',
    assets: {
      normal: 'https://st.deviantart.net/badges/raven.gif',
      huge: 'https://st.deviantart.net/badges/huge/raven.gif',
    },
  },
  {
    id: 18114229,
    typeId: 121,
    name: 'HowtoDrawaWitch',
    title: 'How to Draw a Witch',
    baseTitle: 'How to Draw a Witch',
    description: 'You participated in the tutorial!',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/howtodrawawitch.gif',
        className: '',
      },
    ],
    descriptionLong:
      'Your awesome submission got you this badge to proudly display on your profile! Stay tuned for more tutorials and badges.',
    buttonText: 'Learn More',
    buttonUrl:
      'https://www.deviantart.lan/team/journal/Tutorial-Draw-a-Witch-with-simoneferriero-920120281',
    assets: {
      normal: 'https://st.deviantart.net/badges/howtodrawawitch.gif',
      huge: 'https://st.deviantart.net/badges/huge/howtodrawawitch.gif',
    },
  },
  {
    id: 3297473,
    typeId: 18,
    name: 'dAbirthday10',
    title: "birthdAy '10",
    baseTitle: "birthdAy '10",
    description: 'decade of deviousness',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/birthday10.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/birthday10.png',
      huge: 'https://st.deviantart.net/badges/huge/birthday10.png',
    },
  },
  {
    id: 3841374,
    typeId: 17,
    name: 'cake',
    title: 'Hungry Hungry Pacman Cake',
    baseTitle: 'Cake',
    description: 'Looking to eat large ice cream scoops',
    stackCount: 11,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/base06.gif',
        className: 'cake-base',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/top05.gif',
        className: 'cake-top',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/wax-blue01.gif',
        className: 'cake-candle cake-candle-top-1',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/wax-blue01.gif',
        className: 'cake-candle cake-candle-top-2',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/wax-blue01.gif',
        className: 'cake-candle cake-candle-top-3',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/wax-blue01.gif',
        className: 'cake-candle cake-candle-top-4',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/wax-blue01.gif',
        className: 'cake-candle cake-candle-top-5',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/flame01.gif',
        className: 'cake-flame cake-flame-top-1',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/flame02.gif',
        className: 'cake-flame cake-flame-top-2',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/flame04.gif',
        className: 'cake-flame cake-flame-top-3',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/flame03.gif',
        className: 'cake-flame cake-flame-top-4',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/flame01.gif',
        className: 'cake-flame cake-flame-top-5',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/cake/11-hungry-hungry-packman-cake.gif',
      huge: 'https://st.deviantart.net/badges/cake/huge/11-hungry-hungry-packman-cake.gif',
    },
  },
  {
    id: 4182694,
    typeId: 21,
    name: 'dTSummit11',
    title: 'Raccoon Tamer',
    baseTitle: 'Raccoon Tamer',
    description: 'Participated in the 2011 dT Army Barracks Raccoon-Con',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/dtsummit11.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/dtsummit11.png',
      huge: 'https://st.deviantart.net/badges/huge/dtsummit11.png',
    },
  },
  {
    id: 5030560,
    typeId: 25,
    name: 'fromage',
    title: 'Fromage Connoisseur',
    baseTitle: 'Fromage Connoisseur',
    description: 'Participated in the 2012 dT offsite in France',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/fromage.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/fromage.png',
      huge: 'https://st.deviantart.net/badges/huge/fromage.png',
    },
  },
  {
    id: 37,
    typeId: 1,
    name: 'llama',
    title: 'Fancy Llama',
    baseTitle: 'Llama',
    description: 'Llamas are awesome!',
    stackCount: 1165,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/llama_fancy.gif',
        className: '',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/llama_sunglasses.gif',
        className: '',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/llama_bowtie.gif',
        className: '',
      },
    ],
    assets: {
      normalComposite: [
        {
          imageUrl: 'https://st.deviantart.net/badges/llama_fancy.gif',
          className: '',
        },
        {
          imageUrl: 'https://st.deviantart.net/badges/llama_sunglasses.gif',
          className: '',
        },
        {
          imageUrl: 'https://st.deviantart.net/badges/llama_bowtie.gif',
          className: '',
        },
      ],
      hugeComposite: [
        {
          imageUrl: 'https://st.deviantart.net/badges/huge/llama_fancy.gif',
          className: '',
        },
        {
          imageUrl: 'https://st.deviantart.net/badges/huge/llama_sunglasses.gif',
          className: '',
        },
        {
          imageUrl: 'https://st.deviantart.net/badges/huge/llama_bowtie.gif',
          className: '',
        },
      ],
    },
  },
  {
    id: 1821618,
    typeId: 3,
    name: 'paranoid',
    title: 'Paranoid',
    baseTitle: 'Paranoid',
    description: 'Wears a tinfoil hat',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/paranoid.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/paranoid.gif',
      huge: 'https://st.deviantart.net/badges/huge/paranoid.gif',
    },
  },
  {
    id: 1821619,
    typeId: 4,
    name: 'dAbirthday09',
    title: "birthdAy '09",
    baseTitle: "birthdAy '09",
    description: 'Enjoys birthday shenanigans',
    stackCount: null,
    images: [{ imageUrl: 'https://st.deviantart.net/badges/cake.gif', className: '' }],
    assets: {
      normal: 'https://st.deviantart.net/badges/cake.gif',
      huge: 'https://st.deviantart.net/badges/huge/cake.gif',
    },
  },
  {
    id: 6011353,
    typeId: 32,
    name: 'deviantgear',
    title: 'I Heart DeviantArt Gear',
    baseTitle: 'I Heart DeviantArt Gear',
    description: 'Proud supporter of deviantGEAR',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/devwear.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/devwear.png',
      huge: 'https://st.deviantart.net/badges/huge/devwear.png',
    },
  },
  {
    id: 6455963,
    typeId: 35,
    name: 'plumber',
    title: 'Master Plumber',
    baseTitle: 'Master Plumber',
    description: 'Awarded for bravery above and beyond the call of duty.',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/plumber.png',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/plumber.png',
      huge: 'https://st.deviantart.net/badges/huge/plumber.png',
    },
  },
  {
    id: 7991986,
    typeId: 38,
    name: 'itscoming',
    title: "I've seen it",
    baseTitle: "I've seen it",
    description: "It's Coming -- Stay Tuned!",
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/itscoming.png?5',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/itscoming.png?5',
      huge: 'https://st.deviantart.net/badges/huge/itscoming.png?5',
    },
  },
  {
    id: 15845986,
    typeId: 63,
    name: 'glass',
    title: 'Quartz',
    baseTitle: 'Quartz',
    description: "It's a big honor to be awarded a Quartz badge!",
    stackCount: 5,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/quartz.svg?3',
        className: '',
      },
    ],
    isBooster: false,
    assets: {
      normal: 'https://st.deviantart.net/badges/quartz.svg?3',
      huge: 'https://st.deviantart.net/badges/huge/quartz.svg?3',
      detailed: 'https://st.deviantart.net/badges/detailed/quartz.svg',
      awardModal: 'https://st.deviantart.net/badges/award_modal__quartz.png?2',
    },
  },
  {
    id: 16616489,
    typeId: 64,
    name: 'emerald',
    title: 'Emerald',
    baseTitle: 'Emerald',
    description: "It's a great honor to be awarded an Emerald badge!",
    stackCount: 2,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/emerald.svg?3',
        className: '',
      },
    ],
    isBooster: false,
    assets: {
      normal: 'https://st.deviantart.net/badges/emerald.svg?3',
      huge: 'https://st.deviantart.net/badges/huge/emerald.svg?3',
      detailed: 'https://st.deviantart.net/badges/detailed/emerald.svg',
      awardModal: 'https://st.deviantart.net/badges/award_modal__emerald.png?2',
    },
  },
  {
    id: 16644803,
    typeId: 65,
    name: 'diamond',
    title: 'Diamond',
    baseTitle: 'Diamond',
    description: "It's the highest of honors to be awarded an exclusive Diamond badge!",
    stackCount: 4,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/diamond.svg?3',
        className: '',
      },
    ],
    isBooster: false,
    assets: {
      normal: 'https://st.deviantart.net/badges/diamond.svg?3',
      huge: 'https://st.deviantart.net/badges/huge/diamond.svg?3',
      detailed: 'https://st.deviantart.net/badges/detailed/diamond.svg',
      awardModal: 'https://st.deviantart.net/badges/award_modal__diamond.png?4',
    },
  },
  {
    id: 17362958,
    typeId: 115,
    name: 'TheHype',
    title: 'Hype',
    baseTitle: 'Hype',
    description: 'You got hyped up!',
    stackCount: 4,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/the_hype.png',
        className: '',
      },
    ],
    giveLabel: 'Help Boost Popularity',
    giveExplanation: 'hype up your favorite deviations',
    isBooster: true,
    assets: {
      normal: 'https://st.deviantart.net/badges/the_hype.png',
      huge: 'https://st.deviantart.net/badges/huge/the_hype.png',
      detailed: 'https://st.deviantart.net/badges/detailed/the_hype.png',
      awardModal: 'https://st.deviantart.net/badges/award_modal__the_hype.png',
    },
  },
  {
    id: 181,
    typeId: 181,
    name: 'CreativeDreamingOctober2024',
    title: 'Creative Dreaming: October 2024',
    baseTitle: 'Creative Dreaming: October 2024',
    description: 'You explored endless Promptibilities!',
    stackCount: null,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/creativedreamingoctober2024.gif',
        className: '',
      },
    ],
    assets: {
      normal: 'https://st.deviantart.net/badges/creativedreamingoctober2024.gif',
      huge: 'https://st.deviantart.net/badges/huge/creativedreamingoctober2024.gif',
    },
  },
];

export const coreBadges = [
  {
    id: 15288336,
    typeId: 63,
    name: 'glass',
    title: 'Quartz',
    baseTitle: 'Quartz',
    description: "It's a big honor to be awarded a Quartz badge!",
    stackCount: 12,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/quartz.svg?3',
        className: '',
      },
    ],
  },
  {
    id: 15315753,
    typeId: 64,
    name: 'emerald',
    title: 'Emerald',
    baseTitle: 'Emerald',
    description: "It's a great honor to be awarded an Emerald badge!",
    stackCount: 7,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/emerald.svg?3',
        className: '',
      },
    ],
  },
  {
    id: 15863596,
    typeId: 65,
    name: 'diamond',
    title: 'Diamond',
    baseTitle: 'Diamond',
    description: "It's the highest of honors to be awarded an exclusive Diamond badge!",
    stackCount: 1,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/diamond.svg?3',
        className: '',
      },
    ],
  },
];

export const coreBadgesLimited = [
  ...coreBadges,
  {
    id: 15863569,
    typeId: 97,
    name: 'limited_valentine_heart',
    title: 'Heart',
    baseTitle: 'Heart',
    description: 'Love is in the air, someone is thinking of you!',
    stackCount: 1,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/limited_valentine.svg?1',
        className: '',
      },
    ],
  },
  {
    id: 17168985,
    typeId: 102,
    name: 'limited_gold_coin',
    title: 'Gold Coin',
    baseTitle: 'Gold Coin',
    description: "Gold Coin: Someone thinks you're golden!",
    stackCount: 3,
    campaignEnd: '2022-03-31T23:59:00-0700',
    campaignIconOverride: 'https://st.deviantart.net/badges/limited_stp_icon.svg',
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/limited_patrick_2022.svg?1',
        className: '',
      },
    ],
  },
];

export const badgesByName = [...badges, ...coreBadges, ...coreBadgesLimited].reduce(
  (object, badge) => {
    if (badge.name) {
      object[badge.name] = badge;
    }
    return object;
  },
  {}
);
